import { ErrorAPI } from "api/Assessor/methods";
import CryptoJS from 'crypto-js';
import { AxiosError } from "axios";
import { getAssembleiasNotificacaoEndpoint, getWSAssembleiasEndpoint } from "library/Apis";
import { Dispatch } from "redux";
import ApiService from "services/ApiService";
import { IReducer } from "store/Reducer";
import { toRequest } from "utils/RequestUtils";
import { assembleiaAssessorActionsRefresh } from "./AssembleiasAssessorActions";
import { AssembleiasAssessorActionTypes } from "./AssembleiasAssessorActionTypes";
import { assembleiaAssociadoActionsRefresh } from "./AssembleiasAssociadoActions";
import { AssembleiasAssociadoActionTypes } from "./AssembleiasAssociadoActionTypes";
import { WSAssembleiasActionTypes, WS_ASSEMBLEIAS_ACTIONS_CLOSE, WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH, WS_ASSEMBLEIAS_ACTIONS_ON_ERROR, WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE, WS_ASSEMBLEIAS_ACTIONS_OPEN } from "./WSAssembleiasActionTypes";
import { IWSAssembleia } from "./WSAssembleiasReducer";

export const wsAssembleiasActionsSendMessage = (
  wsAssembleia: IWSAssembleia | any,
  callbackSuccess?: () => void,
  callbackError?: (error: AxiosError<ErrorAPI> | null) => void
) => {
  return (dispatch: Dispatch<WSAssembleiasActionTypes>, getState: () => IReducer) => {
    const usuario = getState().auth.usuario;
    const authorization = usuario ? usuario!.associadoAccessToken || usuario.ladpAccessToken : null
    new Promise(
      (
        resolve,
        reject: (error: AxiosError<ErrorAPI> | null) => void
      ) => {
        if (!authorization) {
          reject(null);
        } else {
          toRequest(
            ApiService.post,
            [
              `${getAssembleiasNotificacaoEndpoint()}assembleia?authorization=${authorization}`,
              wsAssembleia
            ],
            'assembleiasAssociadoActionsLoadContas'
          ).then(
            () => {
              resolve(undefined);
            },
            (error: AxiosError<ErrorAPI>) => {
              reject(error);
            }
          )
        }
      }
    ).then(
      () => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error: AxiosError<ErrorAPI> | null) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    )
  }
}

const wsPingTime = 10000;
let ws: WebSocket | undefined;
let wsInterval: number | NodeJS.Timeout | null;
const showLog = false;
interface ReceiveWS {
  message: string;
}

export const wsAssembleiasActionsManualRefresh = (): WSAssembleiasActionTypes => {
  return {
    type: WS_ASSEMBLEIAS_ACTIONS_MANUAL_REFRESH
  }
}

const WS_STORAGE = 'ws_currentEvent';

export const setCurrentWSEvent = (idEvento: number) => {
  sessionStorage.setItem(WS_STORAGE, idEvento.toString());
};

export const getCurrentWSEvent = () => {
  const idEventoString = sessionStorage.getItem(WS_STORAGE);
  return idEventoString ? parseInt(idEventoString) : null;
};

export const wsAssembleiasActionsClose = () => {
  return () => {
    if (ws) {
      ws.close();
      ws = undefined;
    }
  }
}

export const wsAssembleiasActionsOpen = (
  authorization: string,
  cpf: string,
  idEvento: number,
  callbackSuccess?: (event?: Event) => void,
  callbackError?: (error?: Event) => void,
  callbackClosed?: (event?: CloseEvent) => void,
) => {
  return (
    dispatch: Dispatch<WSAssembleiasActionTypes | AssembleiasAssessorActionTypes | AssembleiasAssociadoActionTypes>,
    getState: () => IReducer
  ) => {

    const sendMessage = () => {
      if (ws && ws.hasOwnProperty('send')) {
        ws.send('ping');
      }
    }

    const cancelWSInterval = (): boolean => {
      if (typeof wsInterval === 'number') {
        clearInterval(wsInterval);
        wsInterval = null;
        return true;
      }
      return false;
    }

    const dispatchOpened = (event: Event) => {
      wsInterval = setInterval(sendMessage, wsPingTime);
      if (showLog) {
        console.log('WebSocket Opened', event);
      }
      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_OPEN
      });
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(event);
      }
    }

    const dispatchError = (event: Event) => {
      if (showLog) {
        console.log('WebSocket Error', event);
      }
      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_ON_ERROR,
        payload: event
      });
      if (typeof callbackError === 'function') {
        callbackError(event);
      }
    }

    const dispatchOnMessage = (event: MessageEvent) => {
      if (showLog) {
        console.log('WebSocket - Nova Mensagem', event);
      }
      const receive = JSON.parse(event.data) as ReceiveWS;
      const message = CryptoJS.AES.decrypt(
        {
          ciphertext: CryptoJS.enc.Base64.parse(receive.message),
        } as CryptoJS.lib.CipherParams,
        CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY!),
        {
          mode: CryptoJS.mode.CBC as any,
          padding: CryptoJS.pad.Pkcs7,
          iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_IV!),
        }
      ).toString(CryptoJS.enc.Utf8);
      const payload = JSON.parse(message) as IWSAssembleia;
      // console.log("WEB SOCKET ", payload)
      if (payload.id) {
        dispatch({
          type: WS_ASSEMBLEIAS_ACTIONS_ON_MESSAGE,
          payload,
        });
        dispatch(assembleiaAssociadoActionsRefresh(payload));
        dispatch(assembleiaAssessorActionsRefresh(payload));
      }
    }

    const dispatchClosed = (event: CloseEvent) => {
      cancelWSInterval();
      ws = undefined;
      if (showLog) {
        console.log('WebSocket Fechado', event);
      }
      dispatch({
        type: WS_ASSEMBLEIAS_ACTIONS_CLOSE
      });
      if (typeof callbackClosed === 'function') {
        callbackClosed(event);
      }
    }

    
    if (!ws) {
      const params = new URLSearchParams({
        authorization,
        cpf,
        idEvento: idEvento.toString(),
      });
      ws = new WebSocket(`${getWSAssembleiasEndpoint()}?${params}`);
      ws.onopen = dispatchOpened;
      ws.onerror = dispatchError;
      ws.onmessage = dispatchOnMessage;
      ws.onclose = dispatchClosed;
    }
  };
};